import { useStaticQuery, graphql } from "gatsby";

export const menuProfile = () => {
  const data = useStaticQuery(graphql`
    query PROFILE_CONTENT {
      allContentfulMenuLoggin(filter: {titulo: {eq: "Menu usuario Empleo"}}) {
        nodes {
          inicioSesion
          logoMagenta {
            file {
              url
            }
          }
          logoBlack {
            file {
              url
            }
          }
          menuOpciones {
            nombreTag
            slugSubcategorias
            titulo
          }
          opciones {
            tituloBanner
            tipoTitulo
            tituloBoton
            redireccionBoton
            referenciaContenido {
              tituloBanner
              tipoTitulo
              redireccionBoton
              tituloBoton
              referenciaContenido {
                tituloBanner
                tipoTitulo
                redireccionBoton
              }
              imagenPrincipal {
                file {
                  url
                }
              }
            }
          }
          logosHeader {
            description
            file {
              url
            }
          }
        }
      }
    }
  `);

  if (!data?.allContentfulMenuLoggin?.nodes?.length) {
    return null;
  }

  return data.allContentfulMenuLoggin.nodes[0];
};
